import fc from '@/firebaseConfig'
import moment from "moment";

export default {
  namespaced: true,
  state: {
    loading: false,
    erpList: [],
    erpObjectQuery: {
      id: "",
      programName: "",
      apiKey: "",

      timeCreated: "",
      type: 1,
      userName: "",
      password: "",
      serverName: "",
      databaseName: "",
    },
    mDataListUnsubscribeObject: null,
    isModal: false,
  },
  getters: {
    getErpObjectQuery(state) {
      return state.erpObjectQuery
    }
  },
  mutations: {
    setLoading(state, val) {
      state.loading = val
    },
    setErpList(state, val) {
      state.erpList = val
    },
    setModal(state, val) {
      state.isModal = val
    }
  },
  actions: {
    getData({commit, getters}, {id}) {

      commit('setLoading', true)

      const databases = fc.companies.doc(id).collection("Databases")
      let query = databases
      if (this.state.mDataListUnsubscribeObject) { this.state.mDataListUnsubscribeObject() }
      this.state.mDataListUnsubscribeObject = query.onSnapshot((databases) => {
        let erpList = []
        databases.forEach((database) => {
          let erpObjectQuery = {...getters.getErpObjectQuery}
          erpObjectQuery = database.data()
          erpObjectQuery['id'] = database.id
          erpObjectQuery['timeCreated'] = moment(erpObjectQuery['timeCreated'].toDate()).format("llll")
          erpList.push(erpObjectQuery)
        })
        commit('setErpList', erpList)
        commit('setLoading', false)
      });
    },
    getDataListUnsubscribe() {
      if (this.state.mDataListUnsubscribeObject) { 
        this.state.mDataListUnsubscribeObject()
        this.state.mDataListUnsubscribeObject = null
      }
    },
    updateData({commit}, {companyID, data, erpID}) {
      commit('setLoading', true)
      let databaseCollection
      if (erpID) {
        databaseCollection = fc.companies.doc(companyID).collection("Databases").doc(erpID)
      } else {
        databaseCollection = fc.companies.doc(companyID).collection("Databases").doc()
      }
      databaseCollection.set(data, {merge: true}).then(function () {
        commit('setLoading', false)
      }).catch(function (error) {
        console.log(error)
      })
    },
    setModal({commit}) {
      commit('setModal', !this.state.databasesByCompany.isModal)
    },
    deleteData(context, {erpId, companyId}) {
      fc.companies.doc(companyId).collection('Databases').doc(erpId).delete()
        .then()
        .catch((error) => console.log("error", error))
    },
    getErpObject(context, {companyID, id}) {
      return fc.companies.doc(companyID).collection("Databases").doc(id).get().then((response) => {
        return response.data()
      })
    },
  }
}

